<template lang="pug">
#creative_preview_wrap
  b-modal#modal-creative-delete(title='クリエイティブを削除しますか？',"hide-footer")
    .row
      .col-4.offset-2
        b-button("block",variant="default",@click="$bvModal.hide('modal-creative-delete')") いいえ
      .col-4
        b-button("block",variant="default", @click="del") はい
  div.card
    div.card-header.d-flex.p-0
      h3.card-title.p-3(v-if="!sort_mode") プレビュー
      h3.card-title.p-3(v-else="") 並び替え
      ul.nav.nav-pills.ml-auto.p-2
        li.nav-item(v-if="widget_random == 'false'")
          a.nav-link.active(href="#",@click="setSortModeOn",v-if="!sort_mode") 並び替えモード
          a.nav-link.active(href="#",@click="setSortModeOff",v-else="") プレビューモード

    div.card-body
      template(v-if="plan_name == 'free'")
        .callout.callout-warning
          h5 ウィジェットには広告が表示されます
          p 無料プランのためウィジェットには広告が表示されます。広告を非表示にするためには有料プランへのアップグレードが必要です
          a.btn.btn-primary(:href="plan_page_url") プランをアップグレード

      section#creative_preview_wrap(v-if="!sort_mode")
        .article_lists
          .article_list.list(v-if=" title!='' || image!=''|| preview_upload_image_path !='' || link!='' ")
            a.content
              dl
                dt
                  .image(:style="{ backgroundImage: 'url(' + preview_upload_image_path + ')' }", v-if="is_upload_image == 1 && preview_upload_image_path")
                  .image(:style="{ backgroundImage: 'url(' + image + ')' }", v-else-if="is_upload_image == 0 &&!$v.image.$invalid")
                dd
                  h2.text {{title}}
                  p.site-name
                    template(v-if="pr_flag") PR
                    template(v-else) &nbsp;
        .article_lists
          .article_list(
              v-for="(creative, idx) in creatives",
              :class="{ tile_first: isFirstTile(idx), list: isList(idx), tile_border: isBorder(idx), rectan: isRectan(idx)}",
              :key="creative.url_token",
              v-if="limit == '' || limit > idx"
            )
            a.content
              dl
                dt(v-if="creative.image!= ''")
                  .image(:style="{ backgroundImage: 'url(' + creative.upload_image_path + ')' }", v-if="creative.is_upload_image == 1 && creative.upload_image_path")
                  .image(:style="{ backgroundImage: 'url(' + creative.image + ')' }", v-else)
                dd(v-if="isRectan(idx)")
                  .text_wrap
                    h2.text {{creative.title}}
                    p.site-name
                      template(v-if="creative.pr_flag") PR
                      template(v-else) &nbsp;
                  .action_wrap
                    a.action_btn(href="#")
                      img(src="/img/rectan_action_btn.png")
                dd(v-else)
                  h2.text {{creative.title}}
                  p.site-name
                    template(v-if="creative.pr_flag") PR
                    template(v-else) &nbsp;

            .actions(v-if="!sandbox")
              button.btn.btn-xs.btn-default.copy(@click="copy(creative)")
                i.fa.fa-copy
                | コピー
              button.btn.btn-xs.btn-default.edit(@click="edit(creative)", v-if="!creative.edit_mode")
                i.fa.fa-edit
                | 編集
              button.btn.btn-xs.btn-default.edit(@click="clearEdit", v-else="")
                | キャンセル
              button.btn.btn-xs.btn-default.del(@click="openDeleteModal(creative)")
                i.fa.fa-times

      section#creative_preview_sort_wrap(v-else)
        .callout.callout-info ドラッグ&ドロップしてください
        draggable.article_lists(:options="{animation: 200}",v-model="creatives")
          .article_list.list(
              v-for="(creative, idx) in creatives",
              :key="creative.url_token"
            )
            a.content
              dl
                dt(v-if="creative.image!= ''")
                  //- .image(:style="{ backgroundImage: 'url(' + creative.image + ')' }")
                  img.image(:src="creative.image")
                dd
                  h2.text {{creative.title}}
                  p.site-name
                    template(v-if="creative.pr_flag") PR
                    template(v-else) &nbsp;
            .actions
              button.btn.btn-default.sort
                i.fa.fa-bars.handle
    div.card-footer(v-if="!sandbox")
      b-button(variant="primary", @click="openWidgetScriptModal") 貼り付け用タグを取得
</template>

<script>

import { mapState } from 'vuex'

import { required, url } from 'vuelidate/lib/validators'

import Vue from 'vue'

import Draggable from 'vuedraggable';

//api
import ActionLogApi from '../apis/action_log'

export default {
  data(){
    return {
      sort_mode: false
    }
  },
  props: {
    token: String,
    url: String,
    widget_id: String,
    plan_name: String,
    plan_page_url: String,
    widget_layout: String,
    widget_random: String,
    limit: String, //クリエイティブ数の上限
    sandbox: {type: Boolean, default: false},
  },
  methods: {
    edit(creative){
      this.$store.commit("creative/setEditMode", creative)
    },
    copy(creative){
      this.$store.commit("creative/copy", creative)
    },
    openDeleteModal(creative){
      this.$store.commit("creative/setDeleteId", creative.id)
      this.$bvModal.show('modal-creative-delete')
    },
    async openWidgetScriptModal(){
      this.$store.commit("widget/setToken", this.token)
      this.$store.commit("widget/setUrl", this.url)
      this.$bvModal.show('modal-widget-script')
      await ActionLogApi.create({
        type_name: "show_widget_code"
      })
    },
    async del(){
      await this.$store.dispatch("creative/destroy", {
        widget_id: this.widget_id
      })
      this.$bvModal.hide('modal-creative-delete')
      this.$toasted.success('削除が成功しました')
      await sleep(10000)
      this.$toasted.clear()
    },
    isFirstTile(idx){
      if(this.widget_layout == "all_list"){
        return false
      }
      if(this.widget_layout == "single_rectangle"){
        return false
      }
      return (idx%5 == 0 || (idx-1)%5 == 0)
    },
    isList(idx){
      if(this.widget_layout == "all_list"){
        return true
      }
      if(this.widget_layout == "single_rectangle"){
        return false
      }
      return (!this.isFirstTile(idx))
    },
    isRectan(idx){
      if(this.widget_layout == "single_rectangle"){
        return true
      } else {
        return false
      }
    },
    isBorder(idx){
      if(this.widget_layout == "single_rectangle"){
        return false
      }
      if(this.title!='' || this.image!='' || this.link!=''){
        idx = idx + 1
      }
      return (idx%5 == 0)
    },
    async clearEdit(){
      this.$store.commit("creative/clearEditMode", this.$store.getters["creative/findEdit"])
    },
    setSortModeOn(e){
      e.preventDefault()
      this.sort_mode = true
    },
    setSortModeOff(e){
      e.preventDefault()
      this.sort_mode = false
    }
  },
  mounted(){
  },
  watch: {
  },
  computed: {
    title(){
      return this.$store.state.creative.preview_list.title
    },
    image(){
      return this.$store.state.creative.preview_list.image
    },
    link(){
      return this.$store.state.creative.preview_list.link
    },
    pr_flag(){
      return this.$store.state.creative.preview_list.pr_flag
    },
    is_upload_image(){
      return this.$store.state.creative.preview_list.is_upload_image
    },
    preview_upload_image_path(){
      return this.$store.state.creative.preview_upload_image_path
    },
    creatives: {
      get() {
				return this.$store.state.creative.lists
			},
			async set(val) {
				//console.log(value)
        this.$toasted.clear()
        //this.$store.commit("creative/setLists", val)
        await this.$store.dispatch("creative/updateOrder",{
          lists: val
        })
        this.$toasted.success('並び替えが成功しました')
        await sleep(10000)
        this.$toasted.clear()
			}
    },
  },
  validations: {
    title: {
      required
    },
    image: {
      required,
      url
    },
    link: {
      required,
      url
    },
  },
  components: {
    Draggable,
  },
  async mounted(){
    await Vue.nextTick()
    if(!this.sandbox){
      await this.$store.dispatch("creative/search", {
        widget_id: this.widget_id
      })
    }
    //console.log(this.limit)
  },
}
</script>
<style lang="scss" scoped>
.callout{
  a{
    color:white;
    text-decoration:none;
  }
}
.callout-info{
  .fa{
    &:before{
      margin-right:10px;
    }
  }
}
</style>
